const BUTTON_NAMES = {
  AUTH: "auth",
  CONFIRM: "confirm",
  PAYMENT: "payment",
};

export default BUTTON_NAMES;
